"use client"

import Script from "next/script"

/**
 * RB2B visitor de-anonymization snippet. Loads on the public marketing site
 * (via PageShell) to identify anonymous US B2B visitors who don't convert.
 * Not rendered on the authenticated dashboard.
 */
export function Rb2b() {
  return (
    <Script id="rb2b" strategy="afterInteractive">
      {`!function(key) {if (window.reb2b) return;window.reb2b = {loaded: true};var s = document.createElement("script");s.async = true;s.src = "https://ddwl4m2hdecbv.cloudfront.net/b/" + key + "/" + key + ".js.gz";document.getElementsByTagName("script")[0].parentNode.insertBefore(s, document.getElementsByTagName("script")[0]);}("DNXY8HDV7QO0");`}
    </Script>
  )
}
